class {
  onCreate() {
    this.state = {
      query: null,
      lang: "CN",
      buttonText: "中文"
    };
  }

  change({ value }) {
    this.state.query = value;
  }
  clear(e) {
    this.state.query = "";
  }

  handleKeypress({ originalEvent, value }) {
    if (originalEvent.key == "Enter") {
      this.state.query = value;
      this.handleClickEvent({ originalEvent, value });
    }
  }

  handleLangSelect(event) {
    this.state.lang = this.state.lang == "CN" ? "EN" : "CN";
    this.state.buttonText = this.state.lang == "CN" ? "中文" : "English";
  }

  handleClickEvent(event) {
    this.emit("search", {
      queryValue: this.state.query,
      queryLang: this.state.lang,
    });
  }
}

<div>
    <div>
        <div>
            <div.search-lang>
                <ebay-button#lang-cn priority="secondary" on-click("handleLangSelect") >${state.buttonText}</ebay-button>
            </div>
            <div.search-form><!-- input search -->
                <div>
                    <img src="logo.001.png" style="width:30px;margin: 4px 12px 0px 8px;"/>
                </div>
                <div.search-textbox>
                    <ebay-textbox#queryText
                        key="textbox"
                        value=state.query
                        button-aria-label="Clear"
                        on-change("change")
                        on-keypress("handleKeypress")
                        on-button-click("handleClickEvent")>
                        <@postfix-icon>
                            <ebay-search-active-icon/>
                        </@postfix-icon>
                    </ebay-textbox>
                    <if(!input.isLoggedIn)>
                      <div.msg-marketing>未注册用户只能查询部分特定网站</div>
                    </if>
                </div>
                <!-- <div.searchButton>
                    <ebay-button on-click("handleClickEvent")>
                        搜索
                    </ebay-button>
                </div> -->
                         
            </div>
        </div>
    </div>
</div>